<template>
    <div :key="id" v-if="product" v-bind:class="{ 'kobler': kobler }" class="splide__slide">
        <div class="splide__slide__row">
            <div class="splide__slide splide__slide--col">
                <div class="product-block product-thumb">
                    <div class="image">
                        <span class="sale-label" v-if="product.priceMode != 2 && product.oldPrice > 0"
                            v-bind:class="{ 'big-sale': discount(product) >= 30 }">{{
                                discount(product) }}%</span>
                        <span class="sale-label big-sale" v-if="product.priceMode == 2">Call</span>
                        <div class="image-1">
                            <router-link :to="productLink">
                                <img :src="resizeImage(product.avatar, 200, 200)" class="img-fluid" />
                            </router-link>
                        </div>
                        <div class="image-2">
                            <router-link :to="productLink">
                                <img v-if="product.images3 && product.images3[1]" class="img-fluid hover-image"
                                    :src="resizeImage(product.images3[1], 200, 200)" />
                                <img v-if="!product.images3 || !product.images3[1]" class="img-fluid hover-image"
                                    :src="resizeImage(product.avatar, 200, 200)" />
                            </router-link>
                        </div>


                    </div>
                    <div class="content">
                        <div class="description">
                            <div class="options pt-1 pb-1" v-if="kobler && product.productOptions">
                                <img :src="oa.colorAvatar" alt="" v-for="oa in product.productOptions" :key="oa">
                            </div>
                            <h4><router-link :to="productLink">{{
                                product.name }}</router-link></h4>

                            <div class="rating d-none">
                                <span class="fa-stack"><i class="fa-regular fa-star fa-stack-1x"></i></span>
                                <span class="fa-stack"><i class="fa-regular fa-star fa-stack-1x"></i></span>
                                <span class="fa-stack"><i class="fa-regular fa-star fa-stack-1x"></i></span>
                                <span class="fa-stack"><i class="fa-regular fa-star fa-stack-1x"></i></span>
                                <span class="fa-stack"><i class="fa-regular fa-star fa-stack-1x"></i></span>
                            </div>

                            <div class="price">
                                <span class="price-new">{{ showPrice(product) }}<span
                                        v-if="kobler">/m<sup>2</sup></span></span>
                                <span class="price-old" v-if="product.oldPrice">{{ price(product.oldPrice) }}</span>
                            </div>

                            <p v-if="product.productSubline" class="desc">{{ product.productSubline }}</p>

                            <button class="btn btn-add-to-cart" v-on:click="addToCart">
                                <i class="fal fa-cart-plus"></i>
                            </button>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="animation-cart" :style="animationStyle"
            v-bind:class="{ 'show': showAnimation, 'move': moveAnimation }">
            <div class="cen">
                <img v-if="product.images3 && product.images3[1]" class="img-fluid hover-image"
                    :src="resizeImage(product.images3[1], 200, 200)" />
                <img v-if="!product.images3 || !product.images3[1]" class="img-fluid hover-image"
                    :src="resizeImage(product.avatar, 200, 200)" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["id", "kobler"],
    data() {
        return {
            animationStyle: "",
            showAnimation: false,
            moveAnimation: false,
        };
    },
    computed: {
        product() {
            return this.$store.getters.product(this.id);
        },

        productLink() {
            if (this.product && this.product.name) {
                return `/san-pham/${this.removeVietnameseTones(this.product.name).replaceAll(" ", "-").toLowerCase()}.${this.productId(this.product)}`;
            } else {
                return `/san-pham/san-pham/${this.productId(this.product)}`;
            }
        },
    },
    components: {
    },
    mounted() { },
    methods: {
        resizeImage(link, width, height) {
            const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
            if (test) {
                // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
                return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
            } else {
                return link;
            }
        },
        productId(p) {
            if (p.mysql_id) {
                return p.mysql_id;
            }
            return p._id;
        },
        discount(p) {
            if (p.priceMode == 1) {
                return p.priceLevel;
            }
            let oldPrice = Number(p.oldPrice);
            let price = Number(p.price);
            return Math.floor(((oldPrice - price) / oldPrice) * 100);
        },
        addToCart() {
            let dom = this.$el.querySelector('.btn-add-to-cart');
            let domImage = this.$el.querySelector('.image-1');
            let rectImage = domImage.getBoundingClientRect();

            this.animationStyle = `top: ${rectImage.top}px; left: ${rectImage.left}px; width: ${rectImage.width}px; height: ${rectImage.height}px;`;
            const t = this;
            t.showAnimation = true;
            dom.classList.add("btn-react");
            setTimeout(function () {
                dom.classList.remove("btn-react");
            }, 200)
            setTimeout(function () {
                t.moveAnimation = true;
            }, 500)

            setTimeout(function () {

                t.showAnimation = false;
                t.moveAnimation = false;
                t.$store.commit("addToCart", t.product._id);
            }, 1700)
        },
        removeVietnameseTones(str) {
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            // Some system encode vietnamese combining accent as individual utf-8 characters
            // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
            // Remove extra spaces
            // Bỏ các khoảng trắng liền nhau
            str = str.replace(/ + /g, " ");
            str = str.trim();
            // Remove punctuations
            // Bỏ dấu câu, kí tự đặc biệt
            str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
            return str;
        },
        showPrice(p) {
            if (p.priceMode == 1) {
                return this.price(Math.round(Number(p.oldPrice) * (100 - Number(p.priceLevel)) / 100));
            } else if (p.priceMode == 2) {
                return p.priceShortMess;
            }
            return this.price(p.price);
        },
        price(price) {
            const config = {
                style: 'currency',
                currency: 'VND',
                maximumFractionDigits: 0
            };
            return new Intl.NumberFormat('vi-VN', config).format(price);
        },
    },
    watch: {
    },
};
</script>

<style lang="less">
@keyframes scalePulse {

    0% {
        transform: scale(1);
        border-radius: 20px;
        opacity: 1;
    }

    100% {
        transform: scale(1.8);
        border-radius: 30px;
        opacity: 0;
    }
}

.product-wrapper {
    .splide__track {
        .splide__list {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            /*justify-content: space-between;
        flex-wrap: nowrap;
        overflow-x: auto;
        scrollbar-width: thin;
        overflow-y: hidden;*/
            gap: 1px;
            padding: 1px;

            >.splide__slide {
                width: 49%;
                outline: 1px solid #ccc;
                padding: 10px 10px 60px 10px;
                position: relative;

                .splide__slide__row {
                    width: 100%;
                }

                .product-block {
                    .image {
                        padding-top: 100%;
                        width: 100%;
                        position: relative;

                        .image-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            overflow: hidden;

                            a {
                                img {
                                    opacity: 1;
                                }
                            }
                        }

                        .image-2 {
                            position: absolute;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            overflow: hidden;

                            a {
                                img {
                                    opacity: 0;
                                }
                            }
                        }

                        .image-1,
                        .image-2 {
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            text-align: center;

                            a {
                                display: flex;
                                justify-content: center;
                                text-align: center;
                                max-width: 100%;
                                max-height: 100%;

                                img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    transition: opacity .3s;
                                }
                            }
                        }

                        .firer {
                            position: absolute;
                            top: -21px;
                            left: -1px;
                            z-index: 900;
                        }


                        .sale-label {
                            position: absolute;
                            top: 6px;
                            left: 12px;
                            background-color: #11a859;
                            font-size: 11px;
                            z-index: 1000;
                            color: white;
                            line-height: 20px;
                            padding: 0 8px;
                            border-radius: 20px;
                            font-weight: 600;

                            &.big-sale {
                                &::after {
                                    content: "";
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    bottom: 0;
                                    right: 0;
                                    background-color: #ad052c7a;
                                    border-radius: 5px;
                                    z-index: -1;
                                    animation: scalePulse 1s infinite;
                                }

                                &::before {
                                    content: "";
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    bottom: 0;
                                    right: 0;
                                    background-color: #ad052c7a;
                                    border-radius: 5px;
                                    z-index: -1;
                                    animation: 1s scalePulse .5s infinite;
                                }
                            }

                        }

                        .firer+.sale-label {
                            padding: 0 2px;
                            background: none;
                            color: #11a859;
                        }

                        &:hover {
                            >a {
                                img {
                                    &:first-of-type {
                                        opacity: 0;
                                    }

                                    &:nth-of-type(2) {
                                        opacity: 1;
                                    }
                                }

                            }
                        }
                    }

                    .content {
                        .description {
                            h4 {
                                font-size: 14px;
                                font-weight: 500;
                                margin-bottom: 4px;
                                line-height: 22px;
                                display: block;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;

                                a {
                                    color: inherit;
                                    text-decoration: none;
                                }
                            }

                            .rating {
                                display: flex;
                                justify-content: flex-start;
                                flex-wrap: wrap;


                                .fa-stack {
                                    font-size: 10px;
                                    color: #FC0;
                                    width: 15px;
                                }
                            }

                            .options {
                                display: flex;
                                flex-wrap: wrap;
                                gap: 1px;
                                justify-content: center;

                                img {
                                    width: 20px;
                                    border-radius: 50%;
                                    ;
                                }
                            }

                            .price {
                                font-size: 14px;
                                font-weight: bold;
                                color: #11a859;
                                padding-top: 10px;
                                display: flex;
                                justify-content: center;
                                flex-wrap: wrap;

                                .price-new,
                                .price-old {
                                    width: 100%;
                                    text-align: center;
                                }

                                .price-old {
                                    color: rgba(0, 0, 0, .5);
                                    text-decoration: line-through;
                                    font-weight: normal;
                                    font-size: 13px;
                                }
                            }

                            .desc {
                                display: none;
                            }

                            .btn-add-to-cart {
                                background-color: #f5f5f5;
                                color: black;
                                margin: 10px 0;
                                transition: background-color .5s;
                                position: absolute;
                                bottom: 0;
                                left: 10px;
                                right: 10px;

                                &:hover {
                                    background-color: #11a859;
                                    color: white;
                                }
                            }
                        }
                    }
                }

                &:hover {
                    .product-block {
                        .image {

                            .image-1 {
                                a {
                                    img {
                                        opacity: 0;
                                    }
                                }
                            }

                            .image-2 {

                                a {
                                    img {
                                        opacity: 1;
                                    }
                                }
                            }


                        }

                    }

                }

                &.kobler {
                    .product-block {
                        .image .sale-label {
                            background-color: #ed1c25;
                        }

                        .content {
                            .description {

                                .price {
                                    color: black;
                                }

                                .desc {
                                    display: none;
                                }

                                .btn-add-to-cart {
                                    background-color: #f5f5f5;
                                    color: black;
                                    margin: 10px 0;
                                    transition: background-color .5s;
                                    position: absolute;
                                    bottom: 0;
                                    left: 10px;
                                    right: 10px;

                                    &:hover {
                                        background-color: #ed1c25;
                                        color: white;
                                    }
                                }
                            }
                        }
                    }


                }
            }
        }
    }
}


@media (min-width: 500px) {
    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(50% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }

                    .product-block {
                        .content {
                            .description {
                                .price {
                                    font-size: 16px;
                                }

                            }

                        }
                    }
                }
            }
        }
    }
}

@media (min-width: 600px) {

    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(33.3% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }
                }
            }
        }
    }

}


@media (min-width: 768px) {
    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(25% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }
                }
            }
        }
    }
}


@media (min-width: 992px) {
    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(20% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }
                }
            }
        }
    }
}

@media (min-width: 1200px) {
    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(16.6% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }
                }
            }
        }
    }

}


@media (min-width: 1400px) {
    .product-wrapper {
        .splide__track {
            .splide__list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                >.splide__slide {
                    width: calc(14.28% - 2px);
                    padding: 10px 10px 60px 10px;

                    .splide__slide__row {
                        width: 100%;
                    }
                }
            }
        }
    }


}

@keyframes ripple {
    0% {
        width: 0;
        height: 0;
        opacity: 0.7;
    }

    80% {
        width: 200%;
        height: 200%;
        opacity: 0;
    }

    100% {
        width: 200%;
        height: 200%;
        opacity: 0;
    }
}

.splide__slide {
    .btn {
        transition: transform .2s;

        &.btn-react {
            transform: scale(0.8);
        }
    }
}

.animation-cart {
    position: fixed;
    justify-content: center;
    flex-direction: column;
    display: none;
    z-index: 10000;
    opacity: 1;

    .cen {
        display: flex;
        justify-content: center;
        max-height: 100%;
        max-width: 100%;
    }

    img {
        max-width: 100%;
        max-height: 100%;
    }

    &.show {
        display: flex;
        transition: top 1s .5s, left 1s .5s, width 1s .5s, height 1s .5s, opacity 0.8s 0.7s, box-shadow .5s;
    }

    &.move {
        -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
        box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
        top: 10px !important;
        left: calc(100vw - 80px) !important;
        width: 20px !important;
        height: 20px !important;
        opacity: 0;
    }
}
</style>